"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNum = exports.toFixedFun = exports.getColor = void 0;
/**
 *
 * @param num
 * @returns
 */
function getColor(num) {
    if (num == null || num == undefined) {
        return "";
    }
    return Number(num) > 0 ? "price_up" : Number(num) < 0 ? "price_down" : "";
}
exports.getColor = getColor;
/**
 * 保留两位小数
 *
 */
function toFixedFun(vs, tfx) {
    var num = parseFloat(vs), item = "-";
    var tofixed = tfx ? tfx : 2;
    if (num >= 0 || num <= 0) {
        item = num.toFixed(tofixed);
    }
    return item;
}
exports.toFixedFun = toFixedFun;
/**
 * 小数展示处理
 * @param num 原值
 * @param fixed 保留位数
 * @param str 后缀
 * @returns
 */
function formatNum(number, fixed, str) {
    var num = parseFloat(number), item;
    if (num == 0) {
        item = num.toFixed(fixed) + str;
    }
    else if (num) {
        item = num.toFixed(fixed) + str;
    }
    else {
        item = number;
    }
    return item;
}
exports.formatNum = formatNum;
